<template>
    <div>
        <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="1000px" :destroy-on-close="true"
            :before-close="cancel">
            <el-form class="formDiv" label-width="125px" ref="form" :model="form" :rules="rules">
                <el-form-item label="销售" prop="saleUuid" v-if="selectType !== 'view'">
                    <el-select v-model="form.saleUuid" placeholder="请选择销售" filterable
                    @change="getCustomerOption" style="width: 100%;">
                        <el-option v-for="item in DrafterOptions" :key="item.uuid" :label="item.name"
                            :value="item.uuid"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户联系人" prop="customerContactsId" v-if="selectType !== 'view'">
                    <el-select v-model="form.customerContactsId" placeholder="请选择客户联系人" filterable style="width: 100%;">
                        <el-option v-for="item in CustomerOptions" :key="item.id"
                            :label="item.contactName + '-' + item.companyName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="扣除类型" prop="deductionType">
                    <el-select v-model="form.deductionType" placeholder="请选择扣除类型" filterable style="width: 100%;"
                        v-if="selectType !== 'view'">
                        <el-option v-for="item in TypeOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                    <el-input v-model="deductionType" auto-complete="off" placeholder="请选择扣除类型" v-else
                        readonly></el-input>
                </el-form-item>
                <el-form-item label="扣除金额" prop="amount">
                    <el-input v-model="form.amount" auto-complete="off" placeholder="请输入扣除金额"
                        :readonly="selectType === 'view'"></el-input>
                </el-form-item>
                <el-form-item style="width: 90%!important;" label="备注" prop="remark">
                    <el-input :autosize="{ minRows: 3 }" type="textarea" placeholder="请输入内容" v-model="form.remark"
                        maxlength="300" show-word-limit :readonly="selectType === 'view'">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" v-if="selectType !== 'view'">
                <el-button size="small" @click="cancel">取消</el-button>
                <el-button size="small" type="primary" class="title" @click="handle">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getPersonByType, getPersonById } from "@/api/dilivery/customer/person";
import { addDeductionRecords, editDeductionRecords } from "@/api/dilivery/deduction_records";
import { getUserById } from "@/api/dilivery/customer/user";
import { getDataInLocalStorage } from "@/utils/localStorage";
export default {
    name: "AddEditDeductionRecords",
    props: ['showDialog', 'selectType', 'selectDetail'],
    data() {
        return {
            title: '',
            userData:{},
            role:'',
            form: {
                id:'',
                remark: '',
                saleUuid: '',
                customerContactsId:'',
                deductionNumber: '',
                deductionType: '',
                amount: ''
            },
            TypeOptions: [
                { value: 'WITHDRAWAL', label: '提现' },
                { value: 'AGENT_PAYMENT', label: '代付款' },
                { value: 'OFFICE_SUPPLIES', label: '买办公用品' },
                { value: 'HORIZONTAL_PROJECT', label: '横向项目' },
                { value: 'OTHER', label: '其他' },
            ],
            DrafterOptions: [],
            CustomerOptions:[],
            rules: {
                saleUuid: [
                    { required: true, message: '销售不能为空', trigger: 'change' }
                ],
                customerContactsId: [
                    { required: true, message: '客户联系人不能为空', trigger: 'change' }
                ],
                deductionType: [
                    { required: true, message: '扣除类型不能为空', trigger: 'change' }
                ],
                amount: [
                    { required: true, message: '扣除金额不能为空', trigger: 'change' }
                ],
            }
        }
    },
    computed: {
        deductionType() {
            return this.TypeOptions.find(item => item.value === this.form.deductionType)?.label ?? ''
        }
    },
    mounted() {
        this.getDrafterOption()
    },
    watch: {
        'selectType': {
            handler(newVal) {
                if (newVal) {
                    if (newVal === 'edit') {
                        this.title = '编辑扣除记录'
                    } else if (newVal === 'add') {
                        this.title = '添加扣除记录'
                    } else if (newVal === 'view') {
                        this.title = '查看扣除记录'
                    }
                }
            },
            immediate: true
        },
        'selectDetail': {
            handler(newVal) {
                if (newVal && Object.keys(newVal)) {
                    this.form.id = newVal.id
                    this.form.remark = newVal.remark
                    this.form.saleUuid = newVal.saleUuid
                    this.form.customerContactsId = newVal.customerContactsId
                    this.form.deductionNumber = newVal.deductionNumber
                    this.form.deductionType = newVal.deductionType
                    this.form.amount = newVal.amount
                    if (newVal.saleUuid) {
                        this.getCustomerOption(newVal.saleUuid)
                    }
                }
            },
            immediate: true
        },
    },
    created() {
        this.userData = JSON.parse(getDataInLocalStorage('user'))
        this.role = getDataInLocalStorage('role')
    },
    methods: {
        cancel() {
            this.$emit('submit', 'cancel')
        },
        getCustomerOption(salesId) {
            try {
                getUserById(salesId).then(res => {
                    if (res.code === 200) {
                        this.CustomerOptions = res.data;
                    }
                }).catch(err => { })
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取客户信息失败');
            }
        },
        getDrafterOption() {
            try {
                if (['ADMIN', 'MANAGER', 'SALES_ASSI_MANAGER', 'SALES_ASSI'].includes(this.role)) {
                    getPersonByType('SALES', {}).then(res => {
                        if (res.code === 200) {
                            this.DrafterOptions = res.data;
                        }
                    }).catch(err => { })
                } else {
                    getPersonById(this.userData['personUuids'][0], {}).then(res => {
                        if (res.code === 200) {
                            this.DrafterOptions = res.data;
                        }
                    }).catch(err => { })
                }
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取人员信息失败');
            }
        },
        handle() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.selectType === 'add') {
                        addDeductionRecords(this.form).then(res => {
                            if (res.code === 200) {
                                this.$emit('submit', 'confirm')
                                this.$messageUi.success('添加成功')
                            }
                        }).catch(err => {
                        })
                    } else if (this.selectType === 'edit') {
                        editDeductionRecords(this.form).then(res => {
                            if (res.code === 200) {
                                this.$emit('submit', 'confirm')
                                this.$messageUi.success('修改成功')
                            }
                        }).catch(err => {
                        })
                    }
                } else {
                    this.$nextTick(() => {
                        let err = document.getElementsByClassName('is-error')
                        if (err.length) {
                            err[0].scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                            })
                        }
                    })
                    this.$messageUi.error('填写参数不规范，请检查')
                }
            });
        }
    }
}
</script>

<style scoped>
.formDiv {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    width: 45% !important;
}
</style>
